import { Select } from '@customerio/pluma-components/react';
import { useBuilderActions, useMeta } from '@customerio/dryad-react';

export type ConditionTypeSelectProps = {
  nodeId: string;
  currentType: string;
  /**
   * Narrows a picked menu value to a type the surface has a row for; returning
   * null ignores the pick.
   */
  conditionTypeOf: (value: string) => string | null;
};

/**
 * The first control of every condition row: shows the row's type and swaps it
 * via replaceNode, which keeps the row in place and emits a single change
 * notification (no intermediate absent state). Allowed types come from
 * provider meta so the menu tracks the host's workspace gates.
 */
export function ConditionTypeSelect({ nodeId, currentType, conditionTypeOf }: ConditionTypeSelectProps) {
  const meta = useMeta();
  const { replaceNode } = useBuilderActions();

  const changeType = (value: string | null) => {
    if (value == null || value === currentType) {
      return;
    }
    const type = conditionTypeOf(value);
    if (type == null) {
      return;
    }
    replaceNode(nodeId, type);
  };

  return (
    <Select
      data-testid="dryad-condition-type-select"
      ariaLabel="Condition type"
      size="sm"
      options={meta.typeOptions}
      value={currentType}
      onChange={changeType}
      isDisabled={meta.isDisabled}
    />
  );
}
